module.exports = __webpack_public_path__ + "img/efeshop1.30ff513e.png";